export const featureFlags = {
  exampleFlag: { Local: '✅', Dev: '✅', 'Pre-prod': '⛔', Prod: '✅' },
  documentCenterToolbar: { Local: '✅', Dev: '⛔', 'Pre-prod': '⛔', Prod: '✅' },
  customerGbrFooter: { Local: '✅', Dev: '✅', 'Pre-prod': '✅', Prod: '⛔' },
  documentCenter: { Local: '✅', Dev: '⛔', 'Pre-prod': '⛔', Prod: '✅' },
  apiTestPage: { Local: '✅', Dev: '✅', 'Pre-prod': '⛔', Prod: '⛔' },
  positionEvaluationPrePublish: { Local: '✅', Dev: '✅', 'Pre-prod': '⛔', Prod: '⛔' },
  displayEnvironment: { Local: '✅', Dev: '✅', 'Pre-prod': '✅', Prod: '⛔' },
  deputies: { Local: '✅', Dev: '✅', 'Pre-prod': '✅', Prod: '⛔' },
  sendingEmailsNotPossible: { Local: '⛔', Dev: '✅', 'Pre-prod': '⛔', Prod: '⛔' },
  specificSeasonTypes: { Local: '⛔', Dev: '⛔', 'Pre-prod': '⛔', Prod: '✅' },
  incentiveSupport: { Local: '✅', Dev: '✅', 'Pre-prod': '✅', Prod: '✅' },
  incentiveSupportMonitoring: { Local: '✅', Dev: '✅', 'Pre-prod': '✅', Prod: '✅' },
  mercerStanding: { Local: '✅', Dev: '✅', 'Pre-prod': '✅', Prod: '✅' },
  mercerStandingFrozen: { Local: '⛔', Dev: '⛔', 'Pre-prod': '⛔', Prod: '⛔' },
  orgManagement: { Local: '✅', Dev: '✅', 'Pre-prod': '✅', Prod: '✅' },
  restructuring: { Local: '✅', Dev: '✅', 'Pre-prod': '✅', Prod: '⛔' },
  newPdfRendering: { Local: '✅', Dev: '✅', 'Pre-prod': '✅', Prod: '✅' },
  headcountOverview: { Local: '✅', Dev: '✅', 'Pre-prod': '✅', Prod: '✅' },
  endpointGroupsMgmt: { Local: '✅', Dev: '✅', 'Pre-prod': '✅', Prod: '✅' },
  specialPaymentEquity: { Local: '✅', Dev: '✅', 'Pre-prod': '✅', Prod: '✅' },
  chatBot: { Local: '✅', Dev: '✅', 'Pre-prod': '✅', Prod: '⛔' },
  eclTemplateActivityStream: { Local: '✅', Dev: '✅', 'Pre-prod': '✅', Prod: '⛔' },
  inCompanyView: { Local: '✅', Dev: '✅', 'Pre-prod': '✅', Prod: '⛔' },
  exceptionalRecognitions: { Local: '✅', Dev: '✅', 'Pre-prod': '⛔', Prod: '⛔' },
  eclFeatureEnvCookie: { Local: '✅', Dev: '⛔', 'Pre-prod': '✅', Prod: '⛔' },
  talentPools: { Local: '✅', Dev: '✅', 'Pre-prod': '⛔', Prod: '⛔' },
  headcountAdjustments: { Local: '✅', Dev: '✅', 'Pre-prod': '✅', Prod: '⛔' },
  hiringDemandMatching: { Local: '✅', Dev: '✅', 'Pre-prod': '✅', Prod: '⛔' },
  headcountWorktimeTypeEither: { Local: '✅', Dev: '✅', 'Pre-prod': '✅', Prod: '⛔' },
  orgPlanningAi: { Local: '✅', Dev: '✅', 'Pre-prod': '✅', Prod: '⛔' },
  meritReorganization: { Local: '✅', Dev: '✅', 'Pre-prod': '⛔', Prod: '⛔' },
  merit2026: { Local: '✅', Dev: '✅', 'Pre-prod': '⛔', Prod: '⛔' },
  headcountSharedLeadership: { Local: '✅', Dev: '✅', 'Pre-prod': '✅', Prod: '⛔' }
} satisfies FeatureFlags;

export interface FeatureFlags {
  [key: string]: {
    Local: FeatureFlagStatus;
    Dev: FeatureFlagStatus;
    'Pre-prod': FeatureFlagStatus;
    Prod: FeatureFlagStatus;
  };
}
export type FeatureFlagName = keyof typeof featureFlags;
type FeatureFlagStatus = '✅' | '⛔';
